import styled from 'styled-components';

const Label = styled.label`
    text-transform: uppercase;
    font-weight: normal;
    margin: ${props => props.margin || '10px 0 0 0'};
    color: ${props => props.theme.colors.darkgray};
    font-size: 13px;

    &:before {
        content: ${props => props.required && ("'*'")};
        color: ${props => props.theme.colors.flamepea};
        margin-right: 3px;
    }
`;

export default Label;



// WEBPACK FOOTER //
// ./src/components/atoms/inputs/Label.js